import { ThemeProvider } from "@emotion/react";
import {
  createTheme,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
  Box,
  CircularProgress,
  Alert,
  Snackbar,
  Slide,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { themeOptions } from "../../../theme";
import TournamentListTable from "../TournamentListTable";
import MainModal from "../../MainModal";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import {
  createPOTYTournament,
  getAllPotyTournaments,
  getOnePotyTournament,
} from "../../../redux/actions/tournament-action";
import { useDispatch } from "react-redux";
import { getSponsors } from "../../../redux/actions/sponsors-action";
import { getAllCourses } from "../../../redux/actions/courses-action";
import { listAllLeague } from "../../../redux/actions/league-action";
import DateRangeRoundedIcon from "@mui/icons-material/DateRangeRounded";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiDelete, apiPut } from "../../../utils/apiRequests";

import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";

import { pointsMultiplier } from "../../../utils/PotyPointsMultiplier";
import moment from "moment";
import { checkPOTYStatus } from "../../../utils/checkStatus";

const useStyles = makeStyles((theme) => ({
  outlineInputBorder: {
    "& * > fieldset > legend": {
      display: "none",
    },
    "& > fieldset > legend > span": {
      display: "none",
    },
  },
  mainInput: {
    position: "relative",
    minWidth: "200px",
  },
  inputField: {
    border: "1px solid #C4C4C4",
    borderRadius: "5px",
    fontSize: "14px !important",
    outline: "none",
    color: "#000",
    width: "100%",
    height: "100%",
    // paddingLeft: "30px",
    padding: "10px 10px 10px 30px",
    "&:focus": {
      border: "1px solid black",
    },
  },
  searchIcon: {
    color: "#C4C4C4",
    position: "absolute",
    top: "50%",
    left: "10%",
    transform: "translate(-50%,-50%)",
  },
  addIconBtn: {
    backgroundColor: "#06623B !important",
    marginLeft: "10px !important",
    color: "#fff !important",
  },
  addIconButton: {
    background: "#2C633C !important",
    height: "30px",
    width: "30px",
  },
  searchBtn: {
    backgroundColor: "#2C633C !important",
    paddingRight: "20px !important",
    paddingLeft: "20px !important",
    height: "40px",
  },
  bottomIconButton: {
    color: "white",
  },
  iconBtn: {
    backgroundColor: "#2C633C !important",
    padding: 0,
    borderRadius: "10px !important",
  },
  addIcon: {
    color: "white",
  },
  inputLabel: {
    fontWeight: "bold !important",
    color: "black !important",
  },
  tableRow: {
    padding: "20px !important",
  },
  selectBox: {
    border: "1px solid rgba(0, 0, 0, 0.42)",
    borderRadius: "8px",
    margin: "8px 0px",
  },
  inputBox: {
    border: "1px solid rgba(0, 0, 0, 0.42)",
    borderRadius: "8px",
    margin: "8px 0px",
    "& input[type='date' i]::-webkit-calendar-picker-indicator": {
      display: "none !important",
    },
  },
  timeInput: {
    "& > fieldset > legend > span": {
      display: "none",
    },
    "& > div:first-child": {
      //   padding: 0,
    },
    padding: "0 !important",
    // height: "35px",
  },
  clockInputAdornment: {
    backgroundColor: "#2C633C !important",
    color: "white",
    height: "65px !important",
    borderRadius: "5px",
    padding: "0px !important",
    maxHeight: "40px !important",
    width: "40px",
    justifyContent: "center",
    alignItems: "center",
  },
  outlinedInputBox: {
    "& input[type='time' i]::-webkit-datetime-edit": {
      display: "none",
    },
    "& * > fieldset": {
      border: "none",
    },
    padding: 0,
  },
  timeTextField: {
    // backgroundColor: "#2C633C !important",
    // color: "white",
    borderRadius: "5px",
    padding: "0px !important",
    "& input[type='time' i]::-webkit-calendar-picker-indicator": {
      padding: "0px !important",
      margin: "0px !important",
      filter: "invert(1) !important",
    },
    "& input[type='date' i]::-webkit-calendar-picker-indicator": {
      padding: "0px !important",
      margin: "0px !important",
      filter: "invert(1) !important",
    },
    "& input[type='date' i]::-webkit-datetime-edit": {
      display: "none",
    },
  },
}));

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

export default function TournamentList(props) {
  const classes = useStyles();
  const theme = createTheme(themeOptions);
  const timeInputIconRef = useRef(null);
  const dispatch = useDispatch();

  const tournamentData = useSelector(
    (state) => state?.getAllPotyTournamentReducer?.data?.leagues
  );
  const tournamentDataStatus = useSelector(
    (state) => state?.listTournamentReducer
  );

  const sponsorData = useSelector(
    (state) => state?.getSponsorReducer?.data?.data
  );

  const courseData = useSelector((state) => state?.coursesReducer?.data);

  const leagueListData = useSelector(
    (state) => state?.listLeagueReducer?.data?.leagues
  );

  const getOneTournamentList = useSelector((state) => state?.getOneTournament);

  const getAllTournamentList = useSelector(
    (state) => state?.getAllPotyTournamentReducer?.data
  );

  const createTounamentReducer = useSelector(
    (state) => state?.createPotyReducer?.data
  );

  const { role } = useSelector((state) => state.userDetailsReducer);

  //#region state
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMsg] = useState("");
  const [searchText, setSearchText] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [selectedName, setSelectedName] = useState("");
  const [selectedLeagueId, setSelectedLeagueId] = useState("");
  const [mode, setMode] = useState();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [oneTournamentData, setOneTournamentData] = useState([]);
  const [tournamentName, setTournamentName] = useState("");
  const [selectedTournamentId, setSelectedTournamentId] = useState("");
  const [load, setLoad] = useState(false);
  const [startLoading, setStartLoading] = useState(false);

  const [addTournament, setAddTournament] = useState({
    name: "",
    course_id: "",
    sponsor_id: "",
    course_name: "",
    sponsor_name: "",
    league_id: "",
    reg_start_date: "",
    reg_end_date: "",
    tournament_date: "",
    points_multiplier: "100%",
    tee_off: "",
  });
  const [deleteMsg, setDeleteMsg] = useState({
    deleteSucces: false,
    deleteSuccessMsg: "",
    deleteError: false,
    deleteErrorMsg: "",
  });
  const [editMsg, setEditMsg] = useState({
    editError: false,
    editErrorMsg: "",
    editSuccess: false,
    editSuccessMsg: "",
  });

  var leagueSearch = oneTournamentData;

  if (searchText) {
    leagueSearch = oneTournamentData?.filter((val) => {
      if (
        val?.name.toLowerCase().includes(searchText?.toLowerCase()) ||
        val?.league_name.toLowerCase().includes(searchText?.toLowerCase())
      ) {
        return val;
      }
    });
  }

  useEffect(() => {
    if (selectedTournamentId !== "") {
      dispatch(getOnePotyTournament(selectedTournamentId));
    }
  }, [selectedTournamentId, load]);

  const openModal = () => {
    setOpen(true);
  };
  const closeModal = () => {
    setOpen(false);
  };

  const _handleNameOnChange = (e) => {
    setAddTournament({ ...addTournament, name: e.target.value });
  };

  const _handleOnChangeRegStartDate = (e) => {
    const { value } = e.target;
    setAddTournament({ ...addTournament, reg_start_date: value });
  };

  const _handleOnChangeRegEndDate = (e) => {
    const { value } = e.target;
    setAddTournament({ ...addTournament, reg_end_date: value });
  };

  const _handleOnChangeTournamentDate = (e) => {
    const { value } = e.target;
    setAddTournament({ ...addTournament, tournament_date: value });
  };

  const _handleSponsorOnChange = (e) => {
    const { value } = e.target;
    var selectedSponsor = sponsorData?.filter(
      (sp) => sp.name === e.target.value
    );
    setAddTournament({
      ...addTournament,
      sponsor_id: selectedSponsor[0]._id,
      sponsor_name: value,
    });
    // _handleSelectSponsorVal(e);
  };

  const _handleCourseOnChange = (e) => {
    const { value } = e.target;
    var selectedCourse = courseData?.filter((sp) => sp.name === e.target.value);
    setAddTournament({
      ...addTournament,
      course_id: selectedCourse[0]._id,
      course_name: value,
    });
  };

  const _handlePointsMultiplierOnChange = (e) => {
    let pointsMultValue = e.target.value;
    pointsMultValue = pointsMultValue.slice(0, -1);
    setAddTournament({ ...addTournament, points_multiplier: e.target.value });
  };

  const _handleChangeSelectTournament = (e, id, name) => {
    setSelectedTournamentId(id);

    setTournamentName(name);
  };

  const onSubmitCreateTournament = () => {
    if (addTournament.name === "") {
      setSnackbar(true);
      setAlertType("error");
      setAlertMsg("Enter Tournament Name");
      return;
    }

    if (addTournament.course_name === "") {
      setSnackbar(true);
      setAlertType("error");
      setAlertMsg("Select Course");
      return;
    }

    if (addTournament.sponsor_name === "") {
      setSnackbar(true);
      setAlertType("error");
      setAlertMsg("Select Sponsor");
      return;
    }

    if (addTournament.reg_start_date === "") {
      setSnackbar(true);
      setAlertType("error");
      setAlertMsg("Select Registration Start Date");
      return;
    }

    if (addTournament.reg_end_date === "") {
      setSnackbar(true);
      setAlertType("error");
      setAlertMsg("Select Registration End Date");
      return;
    }

    if (addTournament.tournament_date === "") {
      setSnackbar(true);
      setAlertType("error");
      setAlertMsg("Select Tournament Start Date");
      return;
    }

    if (addTournament.reg_end_date < addTournament.reg_start_date) {
      setSnackbar(true);
      setAlertType("error");
      setAlertMsg("Registration End Date is improper");
      return;
    }

    if (addTournament.tournament_date <= addTournament.reg_end_date) {
      setSnackbar(true);
      setAlertType("error");
      setAlertMsg("Tournament Date is improper");
      return;
    }

    let status = checkPOTYStatus(
      addTournament.tournament_date,
      addTournament.reg_start_date,
      addTournament.reg_end_date
    );

    var dataObj = {
      name: addTournament.name,
      course_id: addTournament.course_id,
      sponsor_id: addTournament.sponsor_id,
      league_id: addTournament.league_id,
      reg_start_date: addTournament.reg_start_date,
      reg_end_date: addTournament.reg_end_date,
      tournament_date: addTournament.tournament_date,
      points_multiplier: addTournament.points_multiplier,
      status,
    };

    dispatch(createPOTYTournament(dataObj));
    setStartLoading(true);

    setTimeout(() => {
      setStartLoading(false);
      setLoad(!load);
      setOpen(false);
    }, 2500);
  };

  const onSubmitEditTournament = (e) => {
    let status = checkPOTYStatus(
      addTournament.tournament_date,
      addTournament.reg_start_date,
      addTournament.reg_end_date
    );

    const dataObj = {
      name: addTournament.name,
      course_id: addTournament.course_id,
      sponsor_id: addTournament.sponsor_id,
      league_id: selectedLeagueId,
      reg_start_date: addTournament.reg_start_date,
      reg_end_date: addTournament.reg_end_date,
      tournament_date: addTournament.tournament_date,
      points_multiplier: addTournament.points_multiplier,
      status,
    };

    apiPut(
      `${ApiEndpoints.tournament.base}${ApiEndpoints.tournament.edit}${selectedId}`,
      dataObj,
      (res) => {
        if (res.error == false) {
          if (getAllTournamentList?.error === false) {
            dispatch(
              getOnePotyTournament(getAllTournamentList?.leagues[0]?._id)
            );
            setTournamentName(getAllTournamentList?.leagues[0]?.name);
          }
          setOneTournamentData(getOneTournamentList?.data?.tournaments);
          dispatch(getSponsors());
          dispatch(getAllCourses());
          dispatch(listAllLeague());
          setOpen(false);
          setEditMsg({
            ...editMsg,
            editSuccess: true,
            editSuccessMsg: "Tournament edit successfully",
          });
          setInterval(() => {
            setEditMsg({ ...editMsg, editSuccess: false });
          }, 3000);
          setAddTournament({
            name: "",
            course_id: "",
            sponsor_id: "",
            course_name: "",
            sponsor_name: "",
            league_id: addTournament.league_id,
            reg_start_date: "",
            reg_end_date: "",
            tournament_date: "",
            points_multiplier: "100%",
            tee_off: "",
          });
        } else {
          setEditMsg({
            ...editMsg,
            editError: true,
            editErrorMsg: "Something went wrong",
          });
          setInterval(() => {
            setEditMsg({ ...editMsg, editError: false });
          }, 3000);
        }
      },
      (err) => {
        // console.log('err', err)
      }
    );
  };

  const onSubmitDelete = () => {
    apiDelete(
      `${ApiEndpoints.tournament.base}${ApiEndpoints.tournament.delete}${selectedId}`,
      (res) => {
        if (res.error === false) {
          if (getAllTournamentList?.error === false) {
            dispatch(
              getOnePotyTournament(getAllTournamentList?.leagues[0]?._id)
            );
            setTournamentName(getAllTournamentList?.leagues[0]?.name);
          }
          setOneTournamentData(getOneTournamentList?.data?.tournaments);
          dispatch(getSponsors());
          dispatch(getAllCourses());
          dispatch(listAllLeague());
          setDeleteOpen(false);
          setDeleteMsg({
            ...deleteMsg,
            deleteSucces: true,
            deleteSuccessMsg: res.message,
          });
          setInterval(() => {
            setDeleteMsg({ ...deleteMsg, deleteSucces: false });
          }, 3000);
        } else {
          setDeleteMsg({
            ...deleteMsg,
            deleteError: true,
            deleteErrorMsg: res.message,
          });
        }
      },
      (err) => {}
    );
  };

  const checkBrowser = () => {
    const browserName = window.navigator;
    if (browserName?.vendor == "Apple Computer, Inc.") {
      return true;
    } else {
      return false;
    }
  };

  const isSafari = checkBrowser();

  useEffect(() => {
    if (getAllTournamentList?.error === false) {
      setAddTournament({
        ...addTournament,
        league_id: getAllTournamentList?.leagues[0]?._id,
      });
      dispatch(getOnePotyTournament(getAllTournamentList?.leagues[0]?._id));
      setSelectedTournamentId(getAllTournamentList?.leagues[0]?._id);
      setTournamentName(getAllTournamentList?.leagues[0]?.name);
    }
  }, [getAllTournamentList]);

  useEffect(() => {
    if (getOneTournamentList?.loading === false) {
      setOneTournamentData(getOneTournamentList?.data?.tournaments);
      dispatch(getSponsors());
      dispatch(getAllCourses());
      dispatch(listAllLeague());
    }
  }, [getOneTournamentList, createTounamentReducer]);

  useEffect(() => {
    dispatch(getAllPotyTournaments());
    dispatch(getSponsors());
    dispatch(getAllCourses());
    dispatch(listAllLeague());
    checkBrowser();
  }, []);

  return (
    <>
      <Snackbar
        open={snackbar}
        onClose={() => setSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        TransitionComponent={SlideTransition}
      >
        <Alert
          onClose={() => setSnackbar(false)}
          severity={alertType}
          sx={{ width: "100%" }}
        >
          {alertMessage}!
        </Alert>
      </Snackbar>
      <ThemeProvider theme={theme}>
        <Grid container>
          <Grid item xs={12} p={3}>
            <Grid item container>
              <Grid item xs={12} sx={{ padding: "0px 10px" }}>
                <Grid container item>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>
                      Tournaments
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6} marginTop={{ xs: "10px", md: 0 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Select
                          variant="outlined"
                          value={tournamentName}
                          className={classes.outlineInputBorder}
                          fullWidth
                          label="."
                          sx={{
                            backgroundColor: "#FFF",
                            fontWeight: 700,
                          }}
                        >
                          {tournamentData?.map((item, index) => {
                            return (
                              <MenuItem
                                key={index}
                                value={item?.name}
                                onClick={(e) => {
                                  setAddTournament({
                                    ...addTournament,
                                    league_id: item._id,
                                  });
                                  _handleChangeSelectTournament(
                                    e,
                                    item?._id,
                                    item?.name
                                  );
                                }}
                              >
                                <Grid container item>
                                  <Grid item xs={10}>
                                    {item?.name}
                                  </Grid>
                                </Grid>
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </Grid>
                      <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                        <Box className={classes.mainInput}>
                          <SearchIcon className={classes.searchIcon} />
                          <input
                            type="text"
                            placeholder="Search"
                            className={classes.inputField}
                            onChange={(e) => setSearchText(e.target.value)}
                          />
                        </Box>

                        {(role === "admin" || role === "super") && (
                          <IconButton
                            className={classes.addIconBtn}
                            onClick={() => {
                              openModal();
                              setMode(false);
                              setAddTournament({
                                name: "",
                                course_id: "",
                                sponsor_id: "",
                                course_name: "",
                                sponsor_name: "",
                                league_id: addTournament.league_id,
                                reg_start_date: "",
                                reg_end_date: "",
                                tournament_date: "",
                                points_multiplier: "100%",
                                tee_off: "",
                              });
                            }}
                            size="medium"
                          >
                            <AddIcon fontSize="medium" />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item container mt={3}>
              <Grid item xs={12}>
                {deleteMsg.deleteSuccess || deleteMsg.deleteError ? (
                  <Alert
                    sx={{ marginBottom: "5px" }}
                    severity={deleteMsg.deleteSuccess ? "success" : "error"}
                  >
                    {deleteMsg.deleteSuccess
                      ? deleteMsg.deleteSuccessMsg
                      : deleteMsg.deleteErrorMsg}
                  </Alert>
                ) : (
                  ""
                )}
                {editMsg.editSuccess || editMsg.editError ? (
                  <Alert
                    sx={{ marginBottom: "5px" }}
                    severity={editMsg.editSuccess ? "success" : "error"}
                  >
                    {editMsg.editSuccess
                      ? editMsg.editSuccessMsg
                      : editMsg.editErrorMsg}
                  </Alert>
                ) : (
                  ""
                )}

                {tournamentDataStatus?.loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <CircularProgress color="success" />
                    <Typography mt={1}>Loading...</Typography>
                  </Box>
                ) : (
                  <TournamentListTable
                    tournamentData={leagueSearch}
                    openModal={openModal}
                    setMode={setMode}
                    setSelectedId={setSelectedId}
                    setAddTournament={setAddTournament}
                    addTournament={addTournament}
                    setDeleteOpen={setDeleteOpen}
                    setSelectedName={setSelectedName}
                    setSelectedLeagueId={setSelectedLeagueId}
                    selectedLeagueId={selectedLeagueId}
                  />
                )}
              </Grid>
            </Grid>

            <MainModal
              show={open}
              closeModal={closeModal}
              modalHeadTitle={mode ? "Tournament Edit" : "Tournament Add"}
              btnLeftTitle="Back"
              btnRightTitle={startLoading ? "Loading..." : "Save"}
              width="65%"
              btnCloseModal={(e) => {
                mode ? onSubmitEditTournament(e) : onSubmitCreateTournament();
              }}
              cb={closeModal}
              rightVariant="contained"
              leftVariant="outlined"
            >
              <Grid item container>
                <Grid item xs={12}>
                  <Stack mb={2} spacing={0.5} mt={1}>
                    <InputLabel shrink className={classes.inputLabel}>
                      Name
                    </InputLabel>
                    <TextField
                      required
                      placeholder="Name"
                      className={classes.outlineInputBorder}
                      onChange={_handleNameOnChange}
                      value={addTournament.name}
                      variant="outlined"
                    />
                    <InputLabel
                      shrink
                      className={classes.inputLabel}
                      sx={{ marginTop: "15px !important" }}
                    >
                      Course
                    </InputLabel>

                    <Select
                      variant="outlined"
                      value={addTournament.course_name}
                      onChange={_handleCourseOnChange}
                      className={classes.outlineInputBorder}
                      label="."
                    >
                      {courseData?.map((item, index) => {
                        return (
                          <MenuItem key={index} value={item?.name}>
                            <Grid container item>
                              <Grid item xs={10}>
                                {item.name}
                              </Grid>
                            </Grid>
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <InputLabel
                      shrink
                      className={classes.inputLabel}
                      sx={{ marginTop: "15px !important" }}
                    >
                      Sponsors
                    </InputLabel>

                    <Select
                      variant="outlined"
                      value={addTournament.sponsor_name}
                      onChange={_handleSponsorOnChange}
                      className={classes.outlineInputBorder}
                      label="."
                    >
                      {sponsorData?.map((item, index) => {
                        return (
                          <MenuItem key={index} value={item?.name}>
                            <Grid container item>
                              <Grid item xs={10}>
                                {item?.name}
                              </Grid>
                            </Grid>
                          </MenuItem>
                        );
                      })}
                    </Select>

                    <InputLabel
                      shrink
                      className={classes.inputLabel}
                      sx={{ marginTop: "15px !important" }}
                    >
                      Registration Start Date
                    </InputLabel>
                    <OutlinedInput
                      inputRef={timeInputIconRef}
                      id="outlined-adornment-password"
                      value={addTournament.reg_start_date}
                      className={`${classes.outlineInputBorder} ${classes.timeInput} ${classes.outlinedInputBox}`}
                      startAdornment={
                        <InputAdornment
                          className={classes.clockInputAdornment}
                          position="start"
                          sx
                        >
                          {isSafari ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <DateRangeRoundedIcon
                                sx={{
                                  color: "#FFF",
                                  marginLeft: "5px",
                                  fontSize: "18px",
                                  cursor: "default",
                                }}
                              />
                              <TextField
                                className={classes.timeTextField}
                                type="date"
                                onChange={_handleOnChangeRegStartDate}
                              />
                            </Box>
                          ) : (
                            <TextField
                              className={classes.timeTextField}
                              type="date"
                              onChange={_handleOnChangeRegStartDate}
                            />
                          )}
                        </InputAdornment>
                      }
                      label="."
                    />

                    <InputLabel
                      shrink
                      className={classes.inputLabel}
                      sx={{ marginTop: "15px !important" }}
                    >
                      Registration End Date
                    </InputLabel>
                    <OutlinedInput
                      inputRef={timeInputIconRef}
                      id="outlined-adornment-password"
                      value={addTournament.reg_end_date}
                      className={`${classes.outlineInputBorder} ${classes.timeInput} ${classes.outlinedInputBox}`}
                      startAdornment={
                        <InputAdornment
                          className={classes.clockInputAdornment}
                          position="start"
                        >
                          {isSafari ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <DateRangeRoundedIcon
                                sx={{
                                  color: "#FFF",
                                  marginLeft: "5px",
                                  fontSize: "18px",
                                  cursor: "default",
                                }}
                              />
                              <TextField
                                className={classes.timeTextField}
                                type="date"
                                onChange={_handleOnChangeRegEndDate}
                              />
                            </Box>
                          ) : (
                            <TextField
                              className={classes.timeTextField}
                              type="date"
                              onChange={_handleOnChangeRegEndDate}
                            />
                          )}
                        </InputAdornment>
                      }
                      label="."
                    />

                    <InputLabel
                      shrink
                      className={classes.inputLabel}
                      sx={{ marginTop: "15px !important" }}
                    >
                      Tournament Date
                    </InputLabel>
                    <OutlinedInput
                      inputRef={timeInputIconRef}
                      id="outlined-adornment-password"
                      value={addTournament.tournament_date}
                      className={`${classes.outlineInputBorder} ${classes.timeInput} ${classes.outlinedInputBox}`}
                      startAdornment={
                        <InputAdornment
                          className={classes.clockInputAdornment}
                          position="start"
                        >
                          {isSafari ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <DateRangeRoundedIcon
                                sx={{
                                  color: "#FFF",
                                  marginLeft: "5px",
                                  fontSize: "18px",
                                  cursor: "default",
                                }}
                              />
                              <TextField
                                className={classes.timeTextField}
                                type="date"
                                onChange={_handleOnChangeTournamentDate}
                              />
                            </Box>
                          ) : (
                            <TextField
                              className={classes.timeTextField}
                              type="date"
                              onChange={_handleOnChangeTournamentDate}
                            />
                          )}
                        </InputAdornment>
                      }
                      label="."
                    />

                    <InputLabel
                      shrink
                      className={classes.inputLabel}
                      sx={{ marginTop: "15px !important" }}
                    >
                      Points Multiplier
                    </InputLabel>

                    <Select
                      variant="outlined"
                      onChange={_handlePointsMultiplierOnChange}
                      defaultValue={addTournament.points_multiplier}
                      className={classes.outlineInputBorder}
                      label="."
                    >
                      {pointsMultiplier?.map((item, index) => {
                        return (
                          <MenuItem key={index} value={item}>
                            <Grid container item>
                              <Grid item xs={10}>
                                {item}
                              </Grid>
                            </Grid>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </Stack>
                </Grid>
              </Grid>
            </MainModal>

            <MainModal
              show={deleteOpen}
              closeModal={() => setDeleteOpen(false)}
              modalHeadTitle="Delete Tournament"
              btnLeftTitle="Delete"
              btnRightTitle="Cancel"
              btnCloseModal={() => setDeleteOpen(false)}
              leftVariant="contained"
              rightVariant="outlined"
              sx={{ display: "none" }}
              width="500px"
              cb={onSubmitDelete}
            >
              <Grid item container>
                <Grid item xs={12} mb={2}>
                  <Stack spacing={1}>
                    <div className={classes.modalDescription}>
                      <Typography>
                        Are you sure, you want to delete this tournament?{" "}
                        <Typography variant="h6">{selectedName}</Typography>{" "}
                      </Typography>
                    </div>
                  </Stack>
                </Grid>
              </Grid>
            </MainModal>
          </Grid>
        </Grid>
      </ThemeProvider>
    </>
  );
}
